angular.module('zc.projects')

.directive 'zcCampaignInterestWidgetCartButtonClickRateGraph', ($q, $translate, BaseCampaignInterestWidgetGraph, Chart) ->
  class Graph extends BaseCampaignInterestWidgetGraph
    link: (scope, element, attrs) ->
      addSeries = (interest_widget_cart_button_click_rate_stats, no_interest_widget_cart_button_click_rate_stats) ->
        scope.chartConfig.series = [
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetCartButtonClickRateGraph.iwUsers')
          data: interest_widget_cart_button_click_rate_stats
        ,
          name: $translate.instant('projectsCampaigns.directives.campaignInterestWidgetCartButtonClickRateGraph.wholeSite')
          data: no_interest_widget_cart_button_click_rate_stats
        ]

      scope.getStats = =>
        $q.all [
          scope.getCampaignEventStats(@start_event_name)
          scope.getAccessStats()
        ]

      scope.getChartConfig = ->
        scope.chartConfig = Chart.getChartConfig 'line',
          options:
            tooltip:
              valueSuffix: '%'
              valueDecimals: 2
            legend: false
            yAxis: [
              min: 0
              labels:
                formatter: ->
                  Highcharts.numberFormat(this.value, 2) + '%'
              title:
                text: null
            ]

      scope.addChartConfig = ([campaign_event_stats, access_stats]) ->
        access_stats_by_start_at = {}
        for stats in access_stats
          start_at = stats.start_at.valueOf()
          access_stats_by_start_at[start_at] = stats
        interest_widget_cart_button_click_rate_stats = []
        no_interest_widget_cart_button_click_rate_stats = []
        for event_stat in campaign_event_stats
          start_at = event_stat.start_at.valueOf()
          access_stat = access_stats_by_start_at[start_at]
          continue unless access_stat
          no_interest_widget_session_count = access_stat.session_count - event_stat.count
          no_interest_widget_cart_button_click_count = access_stat.cart_button_click_count - event_stat.cart_button_click_count
          interest_widget_cart_button_click_rate = if event_stat.count then event_stat.cart_button_click_count / event_stat.count * 100 else 0
          no_interest_widget_cart_button_click_rate = if no_interest_widget_session_count then no_interest_widget_cart_button_click_count / no_interest_widget_session_count * 100 else 0
          interest_widget_cart_button_click_rate_stats.push [start_at, interest_widget_cart_button_click_rate]
          no_interest_widget_cart_button_click_rate_stats.push [start_at, no_interest_widget_cart_button_click_rate]
        addSeries(interest_widget_cart_button_click_rate_stats, no_interest_widget_cart_button_click_rate_stats)

  return new Graph('daily').createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_interest_widget_cart_button_click_rate_graph.coffee